import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import { StripComponent } from './StripComponent';
import { MobileDayStartStrip } from './day-start-strip.mobile';
import { Property } from '../../../app/entities/property';

import type { DayBreakStrip, Strip, Stripboard } from '../../../app/entities';

type ShootingScheduleTableProps = {
  stripboard: Stripboard;
  placeholder?: React.ReactNode;
  properties: Property[];
  shootingDays: Stripboard['shootingDays'];
};

export const MobileShootingScheduleTable: React.FC<ShootingScheduleTableProps> = observer(
  ({ stripboard, placeholder, properties, shootingDays }) => {
    const firstDayBreakStrip = shootingDays?.[0]?.strips?.find(
      (strip) => strip.type === 'dayBreak',
    );

    return (
      <Container>
        {placeholder ? (
          placeholder
        ) : (
          <>
            {firstDayBreakStrip && (
              <MobileDayStartStrip
                stripboard={stripboard}
                strip={firstDayBreakStrip as DayBreakStrip}
              />
            )}

            {shootingDays?.map((shootingDay) => {
              return shootingDay?.strips?.map((strip) => (
                <StripComponent
                  key={strip._id}
                  stripboard={stripboard}
                  properties={properties}
                  strip={strip}
                  screenType="mobile"
                />
              ));
            })}
          </>
        )}
      </Container>
    );
  },
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
